import Debug   from './theme/debug.js';
import Helpers from './theme/helpers.js';

import MobileNavigation from './theme/components/mobile-navigation.js';
import StickyHeader from './theme/components/sticky-header.js';
import Quantity from './theme/components/quantity.js';
import Select from './theme/components/select.js';
import HoverMap from './theme/components/hover-map.js';
import Lightbox from './theme/components/lightbox.js';
import CopyLink from './theme/components/copy-link.js';
import AnimateScroll from './theme/components/animate-scroll.js';
import CloneCoupon from './theme/components/coupon-clone';
import VariableProduct from './theme/components/variable-product';

window.theme = {
    globals: {
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        let theme = this;

        theme.debug = new Debug;
        theme.helpers = new Helpers;

        theme.Quantity = new Quantity;
        theme.Select = new Select;
        theme.MobileNavigation = new MobileNavigation;
        theme.StickyHeader = new StickyHeader;
        theme.HoverMap = new HoverMap;
        theme.Lightbox = new Lightbox;
        theme.CopyLink = new CopyLink;
        theme.AnimateScroll = new AnimateScroll;
        theme.CloneCoupon = new CloneCoupon;
        theme.VariableProduct = new VariableProduct;
    }
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );
